import { MapButton } from '../styles'
import { Variant } from '../../Button/Button'
import Icon from '../../Icon/Icon'
import MenuList from '../../../assets/icons/map-layers.svg'
import { useMapContext } from '../../../contexts/map/MapContext'
import { useIsEmbedded } from '../../../contexts/ui'

const LegendControl = () => {
  const { setLegendActive } = useMapContext()
  const isEmbedded = useIsEmbedded()

  if (isEmbedded) {
    return null
  }

  return (
    <MapButton onClick={() => setLegendActive(true)} variant={Variant.PrimaryInverted}>
      <Icon size={24}>
        <MenuList />
      </Icon>
      Kaartlagen
    </MapButton>
  )
}

export default LegendControl
